import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FwcDatePicker } from '../../../../fwc-lib.js';
import moment from 'moment';
import { DetailsService } from 'src/app/pages/secure/account/details/details.service';
import { NewEnrollmentModel } from 'src/app/pages/secure/new-enrollment/new-enrollment.model';
import { AppConstants } from '../../constants/app-constants';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';
import { ConfigDataService } from '../../services/config-data.service';
import { UserCacheService } from '../../services/user-cache.service';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserDetailsComponent implements OnInit {
  @Input() content: any;
  @Input() aboutYouFormData: any;
  public aboutYouForm: UntypedFormGroup;
  public academicLevelValues: [{
    slug: '',
    label: 'Select a Academic Level'
  }];
  public formSubmitted = false;
  public dob: any;
  datePickerStart: any;
  showStartDate = false;
  participationId: number;
  myDetails: any;
  statesData = [];
  ageError = false;
  public displaySpinner = false;
  academicLevelMatched = false;
  studentIDPatteren: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    public userCacheService: UserCacheService,
    private detailsService: DetailsService,
    public phoneNumberPipe: PhoneNumberPipe,
    private configDataService: ConfigDataService
  ) { 
    let StudentIDPattrenFromCache=this.userCacheService.getUserData(AppConstants.STUDENT_ID_PATTEREN);
    if(StudentIDPattrenFromCache){
       this.studentIDPatteren=StudentIDPattrenFromCache;
    }else{
      this.studentIDPatteren='^[A-Za-z0-9!_@./#&+-]*$';
    }
  }

  ngOnInit(): void {
    const fwcDatePicker = new FwcDatePicker();
    fwcDatePicker.build();
    this.aboutYouForm = this.formBuilder.group({
      studentId: ['', Validators.required],
      firstName: ['', Validators.required],
      middleInitial: [''],
      lastName: ['', Validators.required],
      gender: ['', Validators.required],
      identifyAs: [''],
      academicLevel: ['', Validators.required],
      DOB: ['', Validators.required],
      email: ['', [Validators.required]],
      phoneNumber: ['', Validators.required],
      altPhoneNumber: [''],
      haveUsAddress: ['Yes', Validators.required],
      address: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      emergencyFirstName: [''],
      emergencyRelationship: [''],
      emergencyLastName: [''],
      emergencyPhone: [''],
      emergencyEmail: ['']
    });
    this.participationId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
    const userData = this.userCacheService.getUserData(AppConstants.UserDetails);
    if (userData){
      this.aboutYouFormData = userData.aboutYouData;
    }
    if (this.aboutYouFormData) {
      this.checkAcademicLevel(this.aboutYouFormData);
      this.aboutYouForm.patchValue(this.aboutYouFormData);
      this.datePickerStart = this.aboutYouFormData.DOB;
      this.showStartDate = true;
      if (this.aboutYouFormData.haveUsAddress === 'No'){
          this.usAddress();
      }
    }
    this.setDefaultValues();
  }
  async setDefaultValues() {
    const enrollmentModel: NewEnrollmentModel = this.userCacheService.getUserData(AppConstants.NewEnrollmentModel);
    if (enrollmentModel) {
      this.aboutYouForm.controls.studentId.setValue(enrollmentModel.enrollmentInfoResponse.studentInfoResponse.studentId);
      this.datePickerStart = enrollmentModel.enrollmentInfoResponse.studentInfoResponse.DOB;
      this.aboutYouForm.controls.email.setValue(enrollmentModel.enrollmentInfoResponse.studentInfoResponse.email);
      if (enrollmentModel.enrollmentInfoResponse.academicLevels && enrollmentModel.enrollmentInfoResponse.academicLevels.length > 0) {
        this.academicLevelValues = [{
          slug: '',
          label: 'Select a Academic Level'
        }];
        enrollmentModel.enrollmentInfoResponse.academicLevels.forEach(element => {
          this.academicLevelValues.push({
            label: element.label,
            slug: element.slug
          });
        });
      }
    }
    await this.getUserDetails();
  }

  get form(): { [p: string]: AbstractControl } { return this.aboutYouForm.controls; }


  onSubmitForm(): void {
    this.formSubmitted = true;
  }

  updateDob(e): void {
    if(e && e.detail && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(e.detail)) {
      this.dob = e.detail;
    } else {
      this.dob = moment(e.detail).format('MM/DD/YYYY');
    }
    const dateOfBirth = 'DOB';
    this.aboutYouForm.controls[dateOfBirth].setValue(this.dob);
    this.validateDate(this.dob);
  }

  blurEvent(e): void {
    this.updateDob(e);
  }

  validateDate(e): void {
    const dateOfBirth = 'DOB';
    const isInRange = this.isDateInRange(e);
    const isDateValid = moment(e, 'MM/DD/YYYY', true).isValid();
    if (!isDateValid || !isInRange) {
      this.aboutYouForm.controls[dateOfBirth].setErrors({ 'invalid date': true });
    } else {
      this.dobvalidation(e);
      this.aboutYouForm.controls[dateOfBirth].setErrors(null);
    }
  }
  isDateInRange(date): boolean {
    return moment(date, 'MM/DD/YYYY').isAfter('01/01/1922');
  }
  async getUserDetails(): Promise<any> {
    await this.getStateData();
    const enrollmentId = this.userCacheService.getUserData(AppConstants.ENROLLMENT_ID);
    this.displaySpinner = true;
    this.detailsService.getStudentInfo(this.participationId, enrollmentId).subscribe(data => {
      this.displaySpinner = false;
      const obj: any = data;
      if (obj.status === AppConstants.SUCCESS_STATUS) {
        if(data && data.DOB && data.DOB === '//') {
          data.DOB = '';
        }
        this.myDetails = data;
        if (this.myDetails.state === null){ 
          this.myDetails.state  = '';
        }
        this.userCacheService.setUserData('tempData', JSON.stringify(this.myDetails));
        this.setDetails();
      }
    }, err => {
      this.displaySpinner = false;
      console.log('error occured ', err);
    });
  }

  setDetails(): void {
    this.aboutYouForm.patchValue(this.myDetails);
    this.checkAcademicLevel(this.myDetails);
    this.datePickerStart = this.myDetails.DOB;
    this.showStartDate = true;
  }

  getStateData(): void {
    this.configDataService.getConfigData(['states']).subscribe(data => {
      const obj: any = data;
      if (obj.status === AppConstants.SUCCESS_STATUS) {
        this.statesData = data.configData[0].json_data;
      }
    }, err => {
      console.log('error occured ', err);
    });
  }

  phoneNumberFormat(event, name): void {
    if (event.target.value.length === 10){
    const value = this.phoneNumberPipe.transform(event.target.value);
    this.aboutYouForm.controls[name].setValue(value);
    }
  }

  validateInput(event): any{
    if (((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) && event.target.value.length < 10 && !isNaN(event.key)) {
      return true;
    } else if (event.keyCode === 8 || event.keyCode === 9) {
      return true;
    } else {
      return false;
    }
  }

  removeHyfen(event, name): void{
    const phNumber = event.target.value.replace(/-/gi, '');
    this.aboutYouForm.controls[name].setValue(phNumber);
  }

  dobvalidation(dob): void {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      --age;
    }
    if (age < 14) {
      this.ageError = true;
    }
    else {
      this.ageError = false;
    }
  }

  usAddress(): void{
    if (this.aboutYouForm.value.haveUsAddress === 'No'){
      this.aboutYouForm.controls.address.clearValidators();
      this.aboutYouForm.controls.address.setErrors(null);
      this.aboutYouForm.controls.city.clearValidators();
      this.aboutYouForm.controls.city.setErrors(null);
      this.aboutYouForm.controls.state.clearValidators();
      this.aboutYouForm.controls.state.setErrors(null);
      this.aboutYouForm.controls.zip.clearValidators();
      this.aboutYouForm.controls.zip.setErrors(null);
    } else if (this.aboutYouForm.value.haveUsAddress === 'Yes'){
      this.aboutYouForm.controls.address.setValidators(Validators.required);
      this.aboutYouForm.controls.city.setValidators(Validators.required);
      this.aboutYouForm.controls.state.setValidators(Validators.required);
      this.aboutYouForm.controls.zip.setValidators(Validators.required);
    }
    this.aboutYouForm.updateValueAndValidity();
  }

  checkAcademicLevel(data): void{
    this.academicLevelMatched = false;
    if (this.academicLevelValues){
      for (let i = 0; i < this.academicLevelValues.length; i++){
        if ( this.academicLevelValues[i].slug === data.academicLevel){
          this.academicLevelMatched = true;
          break;
        }
    }
      if (!this.academicLevelMatched){
        this.aboutYouForm.controls.academicLevel.setValue('');
      }
    }
  }

  validateCity(event: any, name): void{
    this.aboutYouForm.controls[name].setValue(event.target.value.trim());
  }
}
